const PicturesAndMediaRule = ({ item }) => ({ item: getExpandedMediaItem(item) })

export const getExpandedMediaItem = (item) => {
  const { picturesAndMedia } = item
  if (picturesAndMedia) {
    return {
      ...item,
      pictures: picturesAndMedia.filter(({ type }) => type === 'image'),
      videos: picturesAndMedia.filter(({ type }) => type === 'video')
    }
  }
  return item
}

export default PicturesAndMediaRule